/**
 * Локалізований датапікер (flatpickr) замість нативного input[type="date"].
 *
 * Нативний інпут показує формат за локаллю БРАУЗЕРА (mm/dd/yyyy на en-US) —
 * не за мовою сайту. flatpickr дає формат під обрану мову (uk/de/en) і
 * однаковий календар у всіх браузерах.
 *
 * ⚠️ AJAX перевірки наявності: сервер чекає check_in/check_out у форматі Y-m-d.
 * flatpickr з altInput лишає ОРИГІНАЛЬНИЙ input (name=check_in) прихованим зі
 * значенням Y-m-d, а показує окремий altInput у людському форматі. Тож payload
 * не змінюється.
 */
import flatpickr from 'flatpickr';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import 'flatpickr/dist/flatpickr.css';

export default function datePicker() {
	if (typeof flatpickr !== 'function') return;

	const lang = (window.hotelBooking && window.hotelBooking.lang) || 'uk';
	const locale = lang === 'de' ? German : lang === 'en' ? 'default' : Ukrainian;
	// Людський формат показу: en — «Jan 5, 2026», інакше день.місяць.рік.
	const altFormat = lang === 'en' ? 'M j, Y' : 'd.m.Y';

	// Плейсхолдер підказує клікнути (порожнє поле інакше виглядає «мертвим»).
	const ph = {
		uk: { in: 'Оберіть дату заїзду', out: 'Оберіть дату виїзду' },
		en: { in: 'Select check-in', out: 'Select check-out' },
		de: { in: 'Anreise wählen', out: 'Abreise wählen' },
	}[lang] || { in: 'Оберіть дату', out: 'Оберіть дату' };
	const setPh = (fp, text) => {
		if (fp && fp.altInput) fp.altInput.placeholder = text;
	};

	const base = {
		locale,
		altInput: true,
		altInputClass: 'flatpickr-alt', // для стилю (cursor: pointer)
		altFormat,
		dateFormat: 'Y-m-d', // те, що піде у прихований input і на сервер
		minDate: 'today',
		disableMobile: true, // єдиний вигляд, без падіння на нативний мобільний інпут
	};

	const checkIn = document.querySelector('#booking-in');
	const checkOut = document.querySelector('#booking-out');

	if (checkIn && checkOut) {
		let outPicker;
		const inPicker = flatpickr(checkIn, {
			...base,
			onChange: (dates) => {
				// Виїзд не раніше за заїзд (мінімум — наступний день).
				if (dates[0] && outPicker) {
					const next = new Date(dates[0]);
					next.setDate(next.getDate() + 1);
					outPicker.set('minDate', next);
				}
			},
		});
		outPicker = flatpickr(checkOut, base);
		setPh(inPicker, ph.in);
		setPh(outPicker, ph.out);
	}

	// Решта полів дати на сайті (форми CF7 тощо) — той самий вигляд.
	document.querySelectorAll('input[type="date"]:not(#booking-in):not(#booking-out)').forEach((el) => {
		setPh(flatpickr(el, base), ph.in);
	});
}
